'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');
var mustache = require('mustache');
var nthHookTranslations = require('@narvar/nth-hook-translations');
var TrackPageTitle_module = require('./TrackPageTitle.module.css.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var mustache__default = /*#__PURE__*/_interopDefaultLegacy(mustache);

const TrackPageTitle = () => {
  const {
    trackPageTitle,
    trackingStatus
  } = nthHookTranslations.useTranslations();
  return /*#__PURE__*/React__default["default"].createElement("div", {
    className: TrackPageTitle_module["default"].container
  }, /*#__PURE__*/React__default["default"].createElement("h1", null, mustache__default["default"].render(trackPageTitle ?? '', {
    statusText: trackingStatus
  })));
};
var TrackPageTitle$1 = nthHookTranslations.withTranslationsProvider(TrackPageTitle, {
  translationKeys: ['trackPageTitle', 'trackingStatus']
});

exports.TrackPageTitle = TrackPageTitle;
exports["default"] = TrackPageTitle$1;
